export default function ScrollStory({ steps }) {
  return (
    <section className="story-section relative" data-motion-section data-story>
      <div className="motion-divider" data-motion-divider aria-hidden="true" />
      <div className="container-x story-stage" data-story-stage>
        <div className="story-copy" data-motion-heading>
          <div className="eyebrow">How it works</div>
          <h2 className="h2 mt-4">From form to funding in three stages.</h2>
          <p className="body-lg mt-5">Designed to be precise, fast, and free of friction.</p>

          <div className="story-progress" aria-hidden="true">
            <span className="story-progress-fill" data-story-progress />
          </div>
          <div className="story-index" aria-hidden="true">
            <span>01</span>
            <span>03</span>
          </div>
        </div>

        <div className="story-steps">
          {steps.map((step, index) => (
            <article key={step.n} className="story-step" data-story-step>
              <div className="story-step-number">{step.n}</div>
              <div className="story-step-copy">
                <div className="eyebrow">Stage {step.n}</div>
                <h3 className="story-step-title">{step.title}</h3>
                <p className="body mt-4">{step.body}</p>
              </div>
              <div className="story-step-visual" aria-hidden="true">
                <span className="story-orbit story-orbit-a" />
                <span className="story-orbit story-orbit-b" />
                <span className="story-node">
                  <span>{String(index + 1).padStart(2, "0")}</span>
                </span>
                <span className="story-scan-line" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
